import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X, Phone, ArrowUpRight } from "lucide-react";
import { NAV } from "../data/content";
import { useSettings, isSet, telHref } from "../context/SettingsContext";
import { fileUrl } from "../lib/api";

function Logo({ logoUrl }) {
  if (isSet(logoUrl)) return <img src={fileUrl(logoUrl)} alt="HP Froid & Climatisation" className="h-full w-auto object-contain" />;
  return (
    <span className="font-heading font-black leading-[0.85] tracking-tight text-ink">
      <span className="block text-lg">HP FROID</span>
      <span className="block text-[11px] tracking-[0.25em] text-ice font-bold">&amp; CLIMATISATION</span>
    </span>
  );
}

export default function Header() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const { settings } = useSettings();
  const loc = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  useEffect(() => setOpen(false), [loc.pathname]);

  const phone = settings.phone;

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 inset-x-0 z-50 transition-[background-color,box-shadow,border-color] duration-300 ${scrolled ? "bg-white/85 backdrop-blur-xl border-b border-line shadow-sm" : "bg-white/70 backdrop-blur-md border-b border-transparent"}`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 h-20 flex items-center justify-between gap-6">
        <Link to="/" data-testid="logo-link" className="shrink-0 flex items-center h-full py-1.5">
          <Logo logoUrl={settings.logo_url} />
        </Link>

        <nav className="hidden lg:flex items-center gap-6 xl:gap-7">
          {NAV.map((n) => (
            <Link
              key={n.to}
              to={n.to}
              data-testid={`nav-${n.to.replace(/\//g, "")}`}
              className={`text-sm font-semibold transition-colors hover:text-ice whitespace-nowrap ${loc.pathname === n.to ? "text-ice" : "text-ink"}`}
            >
              {n.label}
            </Link>
          ))}
        </nav>

        <div className="hidden md:flex items-center gap-4 shrink-0">
          <Link to="/demande-de-devis" data-testid="header-devis-btn" className="inline-flex items-center gap-1.5 bg-ice text-white rounded-md px-5 py-2.5 text-sm font-bold hover:bg-icehover transition-transform hover:scale-105">
            Demander un devis <ArrowUpRight size={16} />
          </Link>
        </div>

        <button data-testid="mobile-menu-toggle" className="lg:hidden text-ink p-2" onClick={() => setOpen(!open)} aria-label="Menu">
          {open ? <X size={26} /> : <Menu size={26} />}
        </button>
      </div>

      {open && (
        <div data-testid="mobile-menu" className="lg:hidden bg-white border-t border-line px-6 py-6 flex flex-col gap-1">
          {NAV.map((n) => (
            <Link key={n.to} to={n.to} className="py-3 text-base font-semibold text-ink border-b border-line/60">{n.label}</Link>
          ))}
          <div className="flex flex-col gap-3 mt-5">
            {isSet(phone) && (
              <a href={telHref(phone)} className="flex items-center justify-center gap-2 border border-ink text-ink rounded-md py-3 font-bold"><Phone size={18} /> Appeler</a>
            )}
            <Link to="/demande-de-devis" className="flex items-center justify-center gap-2 bg-ice text-white rounded-md py-3 font-bold">Demander un devis <ArrowUpRight size={18} /></Link>
          </div>
        </div>
      )}
    </header>
  );
}
